'use client'
import { useEffect, useRef } from "react"
import { MapMarker, MarkerProps } from "./types";
import { useMap } from "./MapContext";
import { randomNumber } from "@/migrated-widgets/table-map/utils/random";

const Marker: React.FC<MarkerProps> = (props) => {
    const { map, addMarker, removeMarker } = useMap();

    const id = useRef<MapMarker['id']>(props?.id ?? randomNumber());


    useEffect(() => {

        const _marker = new google.maps.Marker();
        _marker.setOptions({ ...props })

        addMarker({ marker: _marker, id: id.current, position: props.position as google.maps.LatLngLiteral, remove: () => _marker.setMap(null), props })
        return () => {
            removeMarker(id.current)
        }
    }, [])



    return null;
}

export default Marker;